import type React from 'react';

export interface FormFieldProps {
  key?: React.Key;
  label?: string;
  description?: string;
  error?: string;
  children: React.ReactNode;
  required?: boolean;
  className?: string;
}

export function FormField({ label, description, error, children, required, className }: FormFieldProps): JSX.Element {
  const containerClasses = ['flex flex-col', className].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      {label ? (
        <label className="text-sm font-medium text-slate-700 flex items-center gap-1">
          <span>{label}</span>
          {required ? <span className="text-red-600">*</span> : null}
        </label>
      ) : null}
      {description ? <p className="text-xs text-slate-500 mt-1">{description}</p> : null}
      <div className="mt-2">{children}</div>
      {error ? <p className="text-xs text-red-600 mt-1">{error}</p> : null}
    </div>
  );
}
